/**
 * Presentación de horarios en el encabezado de la carta.
 * No interpreta turnos ni cambia la lógica de pedidos; solo parte texto largo.
 */

const SEPARADOR_GRUPO_DIA =
  /\s*[,;]\s*(?=(?:lunes|martes|mi[eé]rcoles|jueves|viernes|s[aá]bado|domingo)\b)/i;

/**
 * Convierte el texto de horario_atencion / horario_reparto en líneas cortas.
 * Un horario breve queda en una sola línea; varios tramos de días se apilan.
 *
 * @param {string|null|undefined} texto
 * @returns {string[]}
 */
export function lineasHorarioEncabezado(texto) {
  const raw = String(texto || "")
    .replace(/\r\n/g, "\n")
    .trim();
  if (!raw) {
    return [];
  }

  return raw
    .split(/\n+/)
    .map((linea) => linea.replace(/\s+/g, " ").trim())
    .filter(Boolean)
    .flatMap((linea) =>
      linea
        .split(SEPARADOR_GRUPO_DIA)
        .map((parte) => parte.trim())
        .filter(Boolean)
    );
}
